const config = {
  API_URL:
  // process.env.PUBLIC_API_URL || "https://nruser.icert24.com/nruser",
  // process.env.PUBLIC_API_URL || "http://192.168.6.250:11010/namba1user",
  
  process.env.PUBLIC_API_URL || "https://nruser.number-ro.com/nruser",
};

export default config;
